import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import {SharedModule} from "../shared/shared.module";
import { EmployeeComponent } from './employee/employee.component';
import { EmployeeWorkTimeComponent } from './employee/employee-work-time/employee-work-time.component';
import { EmployeeEditComponent } from './employee/employee-edit/employee-edit.component';
import { EmployeesComponent } from './employees/employees.component';
import { EmployeeRoleComponent } from './employee/employee-role/employee-role.component';
import { WorkTimeFormComponent } from './employee/employee-work-time/work-time-form/work-time-form.component';
import { EmployeeFiscalYearReportComponent } from './employee/employee-fiscal-year-report/employee-fiscal-year-report.component';
import { AttachmentsComponent } from '../shared/attachments/attachments.component';


@NgModule({
  declarations: [
    EmployeeComponent,
    EmployeesComponent,
    EmployeeEditComponent,
    EmployeeRoleComponent,
    EmployeeWorkTimeComponent,
    WorkTimeFormComponent,
    EmployeeFiscalYearReportComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    AttachmentsComponent
  ]
})
export class EmployeeModule { }
